<script>
export default {
  inject: ['gsap'],
  name: "TitleBannersManagement",
  methods:{
    scrollToForm(){
      if (window.innerWidth <= 700){
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#lead-form2").offset().top -10
        }, 0);
      }
      else{
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#lead-form").offset().top -30
        }, 0);
      }
    }
  },
  mounted() {
    var element = $(".new-places-management")
    this.gsap.to('.management-container-img.second', {
      duration: 2,
      delay:2,
      scrollTrigger: {
        trigger: element, // Элемент, который будет триггером
        start: "top center", // Когда триггер сработает (например, когда верх элемента достигнет центра экрана)
        toggleClass: "active", // Добавляем/убираем класс "active" при срабатывании триггера
        once:true
      }
    });
  }
}
</script>

<template>
  <div class="new-places-management left">
    <span class="reinvest-sms-cloud-block">
      <svg width="604" height="370" viewBox="0 0 604 370" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="path-1-inside-1_680_1037" fill="white">
          <path d="M59.9985 0C26.8616 0.000173987 -0.00146484 26.863 -0.00146484 60V310C-0.00146484 343.137 26.8616 370 59.9985 370H600.294C603.248 370 604.736 365.75 602.795 363.524C595.551 355.211 590.942 343.252 590.758 329.92L590.752 329.092V60C590.752 26.8629 563.89 0 530.752 0H59.9985Z"/>
        </mask>
        <path d="M59.9985 0C26.8616 0.000173987 -0.00146484 26.863 -0.00146484 60V310C-0.00146484 343.137 26.8616 370 59.9985 370H600.294C603.248 370 604.736 365.75 602.795 363.524C595.551 355.211 590.942 343.252 590.758 329.92L590.752 329.092V60C590.752 26.8629 563.89 0 530.752 0H59.9985Z" fill="white"/>
        <path d="M59.9985 0V-8V0ZM-0.00146484 310H-8.00146H-0.00146484ZM59.9985 370V378V370ZM590.758 329.92L582.759 330.03L582.759 330.003L582.759 329.977L590.758 329.92ZM590.752 329.092L582.753 329.148L582.752 329.12V329.092H590.752ZM590.752 60H598.752H590.752ZM602.795 363.524L596.764 368.78L602.795 363.524ZM59.9985 0L59.9986 8C31.2798 8.00015 7.99854 31.2813 7.99854 60H-0.00146484H-8.00146C-8.00146 22.4447 22.4434 -7.9998 59.9985 -8V0ZM-0.00146484 60H7.99854V310H-0.00146484H-8.00146V60H-0.00146484ZM-0.00146484 310H7.99854C7.99854 338.719 31.2799 362 59.9986 362L59.9985 370V378C22.4434 378 -8.00146 347.555 -8.00146 310H-0.00146484ZM59.9985 370V362H600.294V370V378H59.9985V370ZM602.795 363.524L596.764 368.78C588.165 358.912 582.967 345.082 582.759 330.03L590.758 329.92L598.758 329.81C598.918 341.422 602.936 351.509 608.826 358.268L602.795 363.524ZM590.758 329.92L582.759 329.977L582.753 329.148L590.752 329.092L598.752 329.035L598.758 329.863L590.758 329.92ZM590.752 329.092H582.752V60H590.752H598.752V329.092H590.752ZM590.752 60H582.752C582.752 31.2812 559.471 8 530.752 8V0V-8C568.308 -8 598.752 22.4446 598.752 60H590.752ZM530.752 0V8H59.9985V0V-8H530.752V0ZM600.294 370V362C597.416 362 596.151 364.085 595.882 364.809C595.623 365.504 595.356 367.164 596.764 368.78L602.795 363.524L608.826 358.268C612.175 362.11 612.134 367.008 610.878 370.385C609.612 373.79 606.126 378 600.294 378V370Z" fill="#FF9166" mask="url(#path-1-inside-1_680_1037)"/>
      </svg>
      <span class="reinvest-sms-cloud-block-content">
          <span class="reinvest-sms-cloud-block-content-txt">
            Наша компания возьмет на себя весь спектр задач по подготовке и сдаче Вашей квартиры в аренду. <br>
            <br>
            Обеспечим стабильный доход и 100% гарантию сохранности квартиры на весь срок договора.
          </span>
          <span class="btn-free-call black flex flex-xy-center" @click.prevent="scrollToForm()">
            Бесплатный звонок
          </span>
      </span>
    </span>

    <span class="sms-cloud-block-mob-default" style="--sms-color-block:#B2DBBF">
      <span class="sms-cloud-block-content">
        <span class="sms-cloud-block-content-txt">
          Наша компания возьмет на себя весь спектр задач по подготовке и сдаче Вашей квартиры в аренду. <br>
            <br>
            Обеспечим стабильный доход и 100% гарантию сохранности квартиры на весь срок договора.
        </span>
         <span class="btn-num flex flex-xy-center" @click.prevent="scrollToForm()">
           Заказать звонок
         </span>
      </span>
    </span>

    <div class="orange-line-manage">

    </div>
    <span class="accent-title left">Продвинутое управление недвижимостью</span>
    <div class="blue-rectangle-left left mobile-nv"></div>
    <svg class="orange-line-wave mobile-nv" width="1081" height="290" viewBox="0 0 1081 290" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M-44 232C39.5 157 288 273.5 288 273.5C288 273.5 437.5 12 617.5 12C797.5 12 870 232 870 232C870 232 1072.5 238.5 1068 144" stroke="#FF9166" stroke-width="24" stroke-linecap="round"/>
    </svg>

    <div class="management-container-img first left">
      <img src="/assets/manage1.png" alt="management-1">
<!--      <router-link :to="{path : '/ourprojects', hash: '#heart'}" class="geo-info left flex mobile-nv flex-xy-center">-->

<!--        <div class="circle-white flex flex-xy-center">-->
<!--          <svg width="61" height="62" viewBox="0 0 61 62" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--            <path fill-rule="evenodd" clip-rule="evenodd" d="M42.2753 15.7943C49.9082 22.1867 49.9082 34.2057 42.2753 40.5981L32.4798 51.3723C31.6863 52.2451 30.3137 52.2451 29.5202 51.3723L19.7247 40.5981C12.0918 34.2057 12.0918 22.1867 19.7247 15.7943C27.3577 9.40191 34.6423 9.4019 42.2753 15.7943ZM31 35C34.866 35 38 31.866 38 28C38 24.134 34.866 21 31 21C27.134 21 24 24.134 24 28C24 31.866 27.134 35 31 35Z" fill="#FF9166"/>-->
<!--          </svg>-->
<!--        </div>-->
<!--        <span>ЖК “Легендарный”</span>-->
<!--      </router-link>-->

      <!-- <div class="packet-mob left flex flex-xy-center mobile">
        Управление
      </div> -->
    </div>
    <div class="management-container-img second left">
      <img src="/assets/manage2.png" alt="management-2">
<!--      <router-link :to="{path: '/ourprojects', hash: '#heart'}" class="geo-info left flex flex-xy-center mobile-nv">-->
<!--        <div class="circle-white flex flex-xy-center">-->
<!--          <svg width="61" height="62" viewBox="0 0 61 62" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--            <path fill-rule="evenodd" clip-rule="evenodd" d="M42.2753 15.7943C49.9082 22.1867 49.9082 34.2057 42.2753 40.5981L32.4798 51.3723C31.6863 52.2451 30.3137 52.2451 29.5202 51.3723L19.7247 40.5981C12.0918 34.2057 12.0918 22.1867 19.7247 15.7943C27.3577 9.40191 34.6423 9.4019 42.2753 15.7943ZM31 35C34.866 35 38 31.866 38 28C38 24.134 34.866 21 31 21C27.134 21 24 24.134 24 28C24 31.866 27.134 35 31 35Z" fill="#FF9166"/>-->
<!--          </svg>-->
<!--        </div>-->
<!--        <span class="geo-info-text">ЖК “Сердце Столицы”</span>-->
<!--      </router-link>-->
    </div>
    <div class="management-container-img thrid left flex flex-x-center mobile">
      <img src="/assets/our-projects-3.png" alt="management-3">
      <div class="geo-info left flex flex-xy-center mobile-nv">
        <svg width="61" height="62" viewBox="0 0 61 62" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="30.5" cy="31" r="30.5" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M42.2753 15.7943C49.9082 22.1867 49.9082 34.2057 42.2753 40.5981L32.4798 51.3723C31.6863 52.2451 30.3137 52.2451 29.5202 51.3723L19.7247 40.5981C12.0918 34.2057 12.0918 22.1867 19.7247 15.7943C27.3577 9.40191 34.6423 9.4019 42.2753 15.7943ZM31 35C34.866 35 38 31.866 38 28C38 24.134 34.866 21 31 21C27.134 21 24 24.134 24 28C24 31.866 27.134 35 31 35Z" fill="#FF9166"/>
        </svg>
        <span class="geo-info-text">ЖК “ЛАЙНЕР”</span>
      </div>
    </div>

  </div>
</template>

<style scoped>

</style>